import { useEffect, useRef } from "react";

// Opens an authenticated WebSocket to /api/ws and dispatches server events.
// Auto-reconnects every 5s on drop. Callers keep their polling as fallback.
export function useRealtime(onMessage) {
  const handlerRef = useRef(onMessage);
  handlerRef.current = onMessage;

  useEffect(() => {
    const base = process.env.REACT_APP_BACKEND_URL;
    if (!base || !localStorage.getItem("access_token")) return;
    let ws;
    let closed = false;
    let retry;
    const connect = () => {
      const token = localStorage.getItem("access_token");
      if (!token) return;
      try {
        ws = new WebSocket(`${base.replace(/^http/, "ws")}/api/ws?token=${encodeURIComponent(token)}`);
      } catch {
        retry = setTimeout(connect, 5000);
        return;
      }
      ws.onmessage = (e) => {
        try {
          handlerRef.current?.(JSON.parse(e.data));
        } catch {}
      };
      ws.onclose = () => {
        if (!closed) retry = setTimeout(connect, 5000);
      };
      ws.onerror = () => {
        try { ws.close(); } catch {}
      };
    };
    connect();
    return () => {
      closed = true;
      clearTimeout(retry);
      try { ws?.close(); } catch {}
    };
  }, []);
}
